export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_LEAD_TIME':
      return { ...state, leadTime: action.leadTime };
    case 'GET_LEAD_TIMES':
      return { ...state, leadTimes: action.leadTimes };
    default:
      return state;
  }
};
